import { darkBlue } from 'src/styles/colors';
import styled from 'styled-components';

const HorizontalLine = styled.hr`
  border-top: 2px solid ${darkBlue};
`;

export default HorizontalLine;
